module.exports = __webpack_public_path__ + "img/turbo_on.3a908502.png";